import { createComponent } from '@carvana/merch-components';

export const Label = createComponent('span', {
  className: 'line-clamp-1 self-stretch text-center text-[#939393]'
});

export const Placeholder = createComponent('div', {
  className:
    'flex h-full w-full flex-col items-center justify-center bg-background-muted-hint'
});
